import React from 'react'
import { Box, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'

const ConfirmLeaveView = ({ formikProps, setPageState, mutation, setSubmitError }) => {
  const { values, handleSubmit } = formikProps

  return (
    <Box
      sx={{
        minHeight: 'calc(70vh - 112px)',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {/* Content here */}
      <Box
        sx={{
          flex: 1,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 2,
          px: 3,
          py: 2,
        }}
      >
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                gap: 2,
              }}
            >
              <Typography width="20%" variant="body1" color="light-gray-text.main">
                Type
              </Typography>
              <Typography width="80%" variant="body1" color="dark-gray-text.main">
                Leave Credit Request
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'start',
                width: '100%',
                gap: 2,
              }}
            >
              <Typography width="20%" variant="body1" color="light-gray-text.main">
                Date
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  width: '80%',
                  flexDirection: { xs: 'column', sm: 'row' },
                  alignItems: 'start',
                  justifyContent: 'start',
                  gap: 1,
                }}
              >
                <Typography variant="body1" color="dark-text.main">
                  {values.startDate} - {values.endDate}
                </Typography>
                <Typography variant="body1" color="alternate.main">
                  ({values.duration} {values.duration > 1 ? 'days' : 'day'})
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                columnGap: 2,
              }}
            >
              <Typography width="20%" variant="body1" color="light-gray-text.main">
                Reason
              </Typography>
              <Typography width="80%" variant="body1" color="dark-gray-text.main">
                {values.reason}
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                height: '50px',
                boxSizing: 'border-box',
                backgroundColor: 'gray-background.main',
                borderRadius: '4.5px',
                display: 'flex',
                alignItems: 'center',
                p: 2,
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="body1" color="light-gray-text.main">
                Leave Days Requested
              </Typography>
              <Typography variant="body1" color="dark-gray-text.main">
                {values.duration} {values.duration > 1 ? 'days' : 'day'}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            backgroundColor: 'gray-background.main',
            borderRadius: '4.5px',
            display: 'flex',
            alignItems: 'center',
            p: 2,
            justifyContent: 'start',
          }}
        >
          <Typography variant="body1" color="light-gray-text.main">
            Make sure all the details are correct before confirming your request.
          </Typography>
        </Box>
      </Box>

      {/* Buttons here */}
      <Box
        sx={{
          position: 'sticky',
          bottom: '0',
          width: '100%',
          display: 'flex',
          justifyContent: { xs: 'center', md: 'end' },
          alignItems: 'center',
          bgcolor: 'primary.light',
          px: 3,
          py: 2,
          gap: 1,
          borderTop: '1px solid',
          borderColor: 'grayscale.line-light',
        }}
      >
        <AdxButton
          variant={'outlined'}
          onClick={() => {
            setSubmitError('')
            setPageState('FILL_LEAVE')
          }}
          sx={{ width: '20%' }}
        >
          Back
        </AdxButton>
        <AdxButton
          variant={'contained'}
          onClick={handleSubmit}
          sx={{ width: '50%' }}
          isLoading={mutation.isLoading}
          disabled={mutation.isLoading}
        >
          Confirm Request
        </AdxButton>
      </Box>
    </Box>
  )
}

export default ConfirmLeaveView
